import { Injectable } from '@angular/core';
import { DocumentEncoding } from 'src/app/distribution/models/document-encoding';

@Injectable({
  providedIn: 'root'
})
export class EncodingPickerService {

  constructor() { }

  public formatEncodingDisplay(item?: DocumentEncoding): string {
    if (item) {
        const display = item.DisplayName ?? '';
        const name = item.Name ?? '';
        const displayLower = display.toLocaleLowerCase();
        const nameLower = name.toLocaleLowerCase();

        return name && displayLower.includes(nameLower)
            ? display
            : `${display} (${name})`;
    }
    return '';
  }
}